/* Keeps <title>, the meta description and the canonical/hreflang links in step with the marketing page on screen
 * (the prerendered HTML already carries them; this covers client-side navigation and language switches). */
import { useEffect } from "react";
import { useI18n } from "../i18n";
import { pageMeta } from "./meta";

function setTag(sel: string, make: () => HTMLElement, attr: string, value: string) {
  let el = document.head.querySelector<HTMLElement>(sel);
  if (!el) { el = make(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
}
const meta = (name: string) => () => Object.assign(document.createElement("meta"), { name });
const link = (rel: string, hreflang?: string) => () => {
  const l = document.createElement("link");
  l.rel = rel;
  if (hreflang) l.hreflang = hreflang;
  return l;
};

export function useSeo(route: string) {
  const { lang } = useI18n();
  useEffect(() => {
    const m = pageMeta(route, lang);
    if (!m) return;
    document.title = m.title;
    setTag('meta[name="description"]', meta("description"), "content", m.description);
    setTag('link[rel="canonical"]', link("canonical"), "href", m.url);
    setTag('link[rel="alternate"][hreflang="en"]', link("alternate", "en"), "href", m.alternates.en);
    setTag('link[rel="alternate"][hreflang="ar"]', link("alternate", "ar"), "href", m.alternates.ar);
  }, [route, lang]);
}
